import { runMutation, runQuery } from '../graphQl'
import * as partIdQuery from '@/api/query/partIdGeneration'
import store from '../../store'

export const getPartIdDataTypes = () => {
  return runQuery(partIdQuery.getPartIdDataTypesQuery(), {}, 'tenant')
}

export const saveSequenceTemplateGeneration = (templateInput, rules) => {
  // if (templateInput !== rules) return
  return runMutation(partIdQuery.saveSequenceTemplateGenerationQuery(), { template_input: templateInput, rules }, 'tenant')
}

export const GetTemplateData = (offset, limit, search, selectedTab, onlyActive = false, featureFilter, createdOnSort = 'desc') => {
  const conditions = {}
  const orderBy = { created_at: createdOnSort }
  if (search?.length) {
    conditions.name = { _ilike: `%${search}%` }
  }
  if (selectedTab === 'MATERIAL') {
    conditions.feature_id = { _in: [1, 6] }
  } else if (selectedTab === 'FACTORIES') {
    conditions.feature_id = { _eq: 12 }
  }
  if (onlyActive) {
    conditions.active = { _eq: true }
  }
  if (featureFilter && featureFilter !== -1) {
    conditions.feature_id = { _eq: featureFilter }
  }
  return runQuery(partIdQuery.getTemplateDataQuery(), { conditions, limit, offset, orderBy }, 'tenant')
}

export const getTemplateById = (templateId) => {
  return runQuery(partIdQuery.getTemplateDetailsQuery(), { templateId }, 'tenant')
}

export const getTenantDefaults = () => {
  const conditions = {}
  if (store?.getters?.collaborator) {
    conditions.tenant_id = { _eq: store.getters?.collaboratorId }
  }
  return runQuery(partIdQuery.getTenantDefaultsQuery(), { conditions }, 'tenant')
}

export const GetIdGenerationRulesByFeatureId = (id, useFactoryToken = false) => {
  let token = 'tenant'
  if (useFactoryToken) {
    token = 'factory'
  }
  return runQuery(partIdQuery.GetIdGenerationRulesByFeatureIdQuery(), { id }, token)
}

export const GetAllSequenceTemplates = (featureId) => {
  return runQuery(partIdQuery.GetAllSequenceTemplatesQuery(), { featureId }, 'tenant')
}

export const DeactivateTemplate = (templateId) => {
  return runMutation(partIdQuery.DeactivateTemplateMutation(), { templateId }, 'tenant')
}
export const ActivateTemplate = (templateId) => {
  return runMutation(partIdQuery.ActivateTemplateMutation(), { templateId }, 'tenant')
}
